import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  key = 'compuBrainKey'
  constructor() { }

  encryptData(data: string): string {

    return CryptoJS.AES.encrypt(data, this.key).toString();

  }

  decryptData(data: string): string {
    const bytes = CryptoJS.AES.decrypt(data, this.key);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  encryptMobileno(data:string):string{
    const key = CryptoJS.enc.Utf8.parse('12345678901234567890123456789012'); // Must be 32 bytes for AES-256
    const iv = CryptoJS.enc.Utf8.parse('1234567890123456'); // Initialization vector
    const encrypted = CryptoJS.AES.encrypt(data, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7}).toString();
    // Make sure it's alphanumeric
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encrypted)); 
  }
}
